import { render, staticRenderFns } from "./add_editk9.vue?vue&type=template&id=9fc140d0&scoped=true&"
import script from "./add_editk9.vue?vue&type=script&lang=js&"
export * from "./add_editk9.vue?vue&type=script&lang=js&"
import style0 from "./add_editk9.vue?vue&type=style&index=0&id=9fc140d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc140d0",
  null
  
)

export default component.exports